import { all } from "redux-saga/effects";
import {
  watchDemoRequestsAction,
  watchGetDashDataAction,
  watchGetPurchaseSummaryAction,
  watchGetPendingDemoRequestAction,
  watchGetRecentTransactionAction,
  watchGetPlantExpireDataAction,
  watchGetRecentRegistrationAction,
  watchPlansAction,
  watchCountryAction,
} from "./dashboardSaga";
import { watchGetCompanyAction, watchGetManagePolicyAction, watchGetPlanHistoryAction, watchGetServiceTypeAction, watchGetSuperAdminsAction } from "./companyDataSaga";
import { watchGeAssignAssetsAction, watchGetAllInvoiceAction, watchGetCustomerAction, watchGetEmpLeaveRequestAction, watchGetEmployeeProfileAction, watchGetEmpSalaryDataAction, watchGetHolidaysAction, watchGetReminderDetailsAction, watchGetSalaryAction } from "./employeeSaga";
import { watchGetEmployeedDataAction, watchGetEmployeeAttendanceAction,watchGetEmployeeLeaveWfhRequestAction, watchGetAssetsAction, watchGetManagerAction, watchGetDeparrtmentAction, watchGetShiftAction, watchGetLeaveAction, watchGetWfhAction, watchGetBranchesAction, watchGetAdminTicketsAction} from "./adminSaga";

function* rootSaga() {
  yield all([
    watchGetDashDataAction(),
    watchGetPurchaseSummaryAction(),
    watchGetPendingDemoRequestAction(),
    watchGetRecentTransactionAction(),
    watchGetPlantExpireDataAction(),
    watchGetRecentRegistrationAction(),

    watchDemoRequestsAction(),
    watchPlansAction(),
    watchGetCompanyAction(),
    watchGetPlanHistoryAction(),
    watchGetServiceTypeAction(),


    watchGetSuperAdminsAction(),

    // saas sagas
    watchGetEmployeeProfileAction(),
    watchGetHolidaysAction(),
    watchGetReminderDetailsAction(),
    watchGetSalaryAction(),
    watchGetEmpLeaveRequestAction(),
    watchGetAllInvoiceAction(),
    watchGetEmpSalaryDataAction(),
    watchCountryAction(),
    watchGeAssignAssetsAction(),

    //Admin Saga
    watchGetEmployeedDataAction(),
    watchGetEmployeeAttendanceAction(),
    watchGetEmployeeLeaveWfhRequestAction(),
    watchGetAssetsAction(),
    watchGetManagerAction(),
    watchGetDeparrtmentAction(),
    watchGetShiftAction(),
    watchGetLeaveAction(),
    watchGetWfhAction(),
    watchGetCustomerAction(),
    watchGetBranchesAction(),
    watchGetManagePolicyAction(),
    watchGetAdminTicketsAction()

  ]);
}

export default rootSaga;
